<template>
    <select :value="modelValue" @change="handleChange" class="my-select">
        <option v-for="item in options" :key="item" :value="item">
            {{ item }} 项目
            <el-icon>
                <SortUp />
            </el-icon>
        </option>
    </select>
</template>

<script setup>
    defineProps({
        modelValue: {
            type: String,
            default: '',
        },
        options: {
            type: Array,
            required: true
        },
    })
    const emit = defineEmits(['update:modelValue'])

    function handleChange(event) {
        const value = event.target.value
        emit('update:modelValue', value)
        window.localStorage.setItem('postvalue', value)
        location.reload()
    }
</script>

<style scoped>
    /* 完全独立的样式，不会影响其他元素 */
    .my-select {
        width: 100%;
        max-width: 125px;
        padding: 3px 3px;
        font-size: 15px;
        color: #fff;
        font-weight: 700;
        background-color: transparent;
        border: none;
        outline: none;
        cursor: pointer;
    }

    .my-select option {
        background-color: transparent;
        color: #000;
    }

    /* 关键：仅本组件的下拉 option hover 颜色 */
    .my-select option:hover {
        background-color: rgb(0, 21, 41) !important;
    }
</style>